<script>
    import { checkbox } from 'vue-strap';
    import Radio from '~componentes/Radio.vue';

    export default {
      components: { checkbox, Radio },
      props: {
        solicitacao: Object,
        carregandoTraducoes: Boolean,
        solicitacaoTraducao: Object,
      },
      data() {
        return {
          configuracao: this.$storage.configuracao(),
        }
      },
      computed: {
        labelDuracao() {
          if (parseInt(this.solicitacao.tipoSolicitacao) == 1) {
            return 'Duração do curso';
          }
          if (parseInt(this.solicitacao.tipoSolicitacao) == 2) {
            return 'Dia e horário do evento';
          }
          return 'Duração';
        },
        labelMetodologia() {
          if (parseInt(this.solicitacao.tipoSolicitacao) == 2) {
            return 'Programação';
          }
          return 'Metodologia';
        },
       resumoContador: function() {
              let quantidadeCaracteres = this.solicitacaoTraducao.resumo ?
                  this.solicitacaoTraducao.resumo.length : 0;

              return 300 - quantidadeCaracteres;
        },
        labelDescricao() {
            if (parseInt(this.solicitacao.tipoSolicitacao) == 1) {
                return 'Nome do curso';
            }
            if (parseInt(this.solicitacao.tipoSolicitacao) == 2) {
                return 'Nome do evento';
            }
            return 'Descrição';
        },
        labelmensagemFinalSalvar() {
            var msg = 'Mensagem de conclusão ao salvar uma ';

            if (this.solicitacao.tipoSolicitacao == 4)
                msg += ' doação.';
            else
                msg += ' inscrição';

            return msg;
        },
      },
      methods: {
        preencherDadosContato() {
          let usuario = this.$storage.usuario();

          this.$set(this.solicitacao, 'nomeSolicitante', usuario.nome);
          this.$set(this.solicitacao, 'emailSolicitante', usuario.email);
          this.$set(this.solicitacao, 'telefoneSolicitante', usuario.telefone.substring(0, 20));
        },
          validarDadosSolicitacao() {
            return this.$validator.validateAll();
          },
      },
      mounted() {
      }
    }
</script>

<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div class="form-group required" :class="{'has-error': errors.has('descricao')}">
                    <label class="control-label" for="documento">{{ labelDescricao }}</label>

                    <input type="text"
                           class="form-control"
                           id="descricao"
                           v-model="solicitacaoTraducao.descricao"
                           data-vv-as="Descrição"
                           data-vv-name="descricao"
                           maxlength="200"
                           :disabled="carregandoTraducoes"
                           v-validate="'required'">

                    <p class="text-danger" v-show="errors.has('descricao')">{{ errors.first('descricao') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <div class="form-group required" :class="{'has-error': errors.has('resumo')}">
                    <label class="control-label" for="resumo">
                        Resumo ({{ resumoContador }})
                    </label>

                    <textarea class="form-control"
                              id="resumo"
                              v-model="solicitacaoTraducao.resumo"
                              data-vv-rules="required"
                              data-vv-as="resumo"
                              data-vv-name="resumo"
                              v-validate
                              :disabled="carregandoTraducoes"
                              maxlength="300">
              </textarea>

                    <p class="text-danger" v-show="errors.has('resumo')">{{ errors.first('resumo') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="mensagemFinalSalvar">
                        {{labelmensagemFinalSalvar}}
                    </label>

                    <textarea class="form-control"
                              id="mensagemFinalSalvar"
                              :disabled="carregandoTraducoes"
                              v-model="solicitacaoTraducao.mensagemFinalSalvar">
              </textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="informacoes-solicitacao">
                        Informações
                    </label>

                    <textarea class="form-control"
                              id="informacoes-solicitacao"
                              :disabled="carregandoTraducoes"
                              v-model="solicitacaoTraducao.informacoes">
          </textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="observacoes-solicitacao">
                        Observações
                    </label>

                    <textarea class="form-control"
                              id="observacoes-solicitacao"
                              :disabled="carregandoTraducoes"
                              v-model="solicitacaoTraducao.observacoes">
          </textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="justificativa-solicitacao">
                        Justificativa
                    </label>

                    <textarea class="form-control"
                              id="justificativa-solicitacao"
                              :disabled="carregandoTraducoes"
                              v-model="solicitacaoTraducao.justificativa">
          </textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="objetivos-solicitacao">
                        Objetivos
                    </label>

                    <textarea class="form-control"
                              id="objetivos-solicitacao"
                              :disabled="carregandoTraducoes"
                              v-model="solicitacaoTraducao.objetivos">
          </textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="metodologia-solicitacao">
                        {{ labelMetodologia }}
                    </label>

                    <textarea class="form-control"
                              id="metodologia-solicitacao"
                              :disabled="carregandoTraducoes"
                              v-model="solicitacaoTraducao.metodologia">
          </textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="infraestrutura-solicitacao">
                        Infraestrutura
                    </label>

                    <textarea class="form-control"
                              id="infraestrutura-solicitacao"
                              :disabled="carregandoTraducoes"
                              v-model="solicitacaoTraducao.infraestrutura">
          </textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="ementaDisciplina-solicitacao">
                        Ementa\Disciplinas
                    </label>

                    <textarea class="form-control"
                              id="ementaDisciplina-solicitacao"
                              :disabled="carregandoTraducoes"
                              v-model="solicitacaoTraducao.ementaDisciplina">
          </textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="preRequisito-solicitacao">
                        Pré-requisito
                    </label>

                    <textarea class="form-control"
                              id="preRequisito-solicitacao"
                              :disabled="carregandoTraducoes"
                              v-model="solicitacaoTraducao.preRequisito">
          </textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="publicoAlvo-solicitacao">
                        Público-alvo
                    </label>

                    <textarea class="form-control"
                              id="publicoAlvo-solicitacao"
                              :disabled="carregandoTraducoes"
                              v-model="solicitacaoTraducao.publicoAlvo">
          </textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="investimento-solicitacao">
                        Valores e categorias para inscerição
                    </label>

                    <textarea class="form-control"
                              id="investimento-solicitacao"
                              :disabled="carregandoTraducoes"
                              v-model="solicitacaoTraducao.investimento">
          </textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="formaPagamento-solicitacao">
                        Formas de pagamento
                    </label>

                    <textarea class="form-control"
                              id="formaPagamento-solicitacao"
                              :disabled="carregandoTraducoes"
                              v-model="solicitacaoTraducao.formaPagamento">
          </textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="devolucaoInscricao-solicitacao">
                        Devolução de inscrição
                    </label>

                    <textarea class="form-control"
                              id="devolucaoInscricao-solicitacao"
                              :disabled="carregandoTraducoes"
                              v-model="solicitacaoTraducao.devolucaoInscricao">
          </textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="local-solicitacao">
                        Local
                    </label>

                    <textarea class="form-control"
                              id="local-solicitacao"
                              :disabled="carregandoTraducoes"
                              v-model="solicitacaoTraducao.local">
          </textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="duracao-solicitacao">
                        {{ labelDuracao }}
                    </label>

                    <textarea class="form-control"
                              id="duracao-solicitacao"
                              :disabled="carregandoTraducoes"
                              v-model="solicitacaoTraducao.duracao">
          </textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="areaConhecimento-solicitacao">
                        Área do conhecimento
                    </label>

                    <textarea class="form-control"
                              id="areaConhecimento-solicitacao"
                              :disabled="carregandoTraducoes"
                              v-model="solicitacaoTraducao.areaConhecimento">
          </textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="outrasInformacoes-solicitacao">
                        Outras informações
                    </label>

                    <textarea class="form-control"
                              id="outrasInformacoes-solicitacao"
                              :disabled="carregandoTraducoes"
                              v-model="solicitacaoTraducao.outrasInformacoes">
          </textarea>
                </div>
            </div>
        </div>

    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-curso-evento-servico/componentes/compartilhado/FormDadosAdicionaisTraducao.vue